import { render, staticRenderFns } from "./BiddingGuidelines.vue?vue&type=template&id=152e2849&scoped=true&"
import script from "./BiddingGuidelines.vue?vue&type=script&lang=js&"
export * from "./BiddingGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./BiddingGuidelines.vue?vue&type=style&index=0&id=152e2849&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e2849",
  null
  
)

export default component.exports